import React from "react"

const GetInTouch = () => {
  return (<>
    <div className='col-6'>
      <div className='form-item'>
        <label htmlFor="FirstName">First Name</label>
        <input type="text" name="FirstName" required placeholder="Your first name" />
      </div>
    </div>
    <div className='col-6'>
      <div className='form-item'>
        <label htmlFor="LastName">Last Name</label>
        <input type="text" name="LastName" required placeholder="Your last name" />
      </div>
    </div>
    <div className='col-12'>
      <div className='form-item'>
        <label htmlFor="ContactEmail">Email</label>
        <input type="email" name="ContactEmail" required placeholder="you@company.com" />
      </div>
    </div>
    <div className='col-12'>
      <div className='form-item form-select'>
        <label htmlFor="EstimatedTraffic">Estimated monthly traffic</label>
        <select name="EstimatedTraffic">
          <option value="I don't know">I don't know</option>
          <option value="Less than 100TB">Less than 100TB</option>
          <option value="100TB - 500TB">100TB - 500TB</option>
          <option value="500TB - 1000TB">500TB - 1000TB</option>
          <option value="1PB - 10PB">1PB - 10PB</option>
          <option value="10PB - 50PB">10PB - 50PB</option>
          <option value="More than 50PB">More than 50PB</option>
        </select>
      </div>
    </div>
    <div className='col-12'>
      <div className='form-item'>
        <label htmlFor="Message">Message</label>
        <textarea name="Message" required minLength={10} placeholder="Tell us about your project and how bunny.net can help."></textarea>
      </div>
    </div>
  </>)
}

export default GetInTouch